import React from 'react';
import classnames from 'classnames';
import * as Classes from '../walls/styles.module.scss';
import * as AppClasses from '../Application/styles.module.scss';

const WallSkeleton = () => (
  <li>
    <div className={ Classes.sharing } />
    <div className={ Classes.wall }>
      <div className={ classnames(Classes.imageHolder, AppClasses.skeleton) } />
      <h3>&nbsp;</h3>
      <p>&nbsp;</p>
    </div>
    <div className={ Classes.shop }>
      <div className={ AppClasses.actionButton } />
    </div>
  </li>
);

export default WallSkeleton;
